import React from 'react'
import PropTypes from 'prop-types'

const TableRow = ({ children, classes, innerRef = null, ...props }) => (
  <tr ref={innerRef} {...props} className={classes}>
    {children}
  </tr>
)

TableRow.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.string,
  innerRef: PropTypes.string,
}

export default TableRow
